/**
 * Umrechnung zwischen `Date` und den Werten der Felder `type="date"` und
 * `type="time"`.
 *
 * Beides steht in **lokaler** Zeit, `Date` trägt einen Zeitpunkt. Der Umweg
 * über die Einzelteile ist deshalb kein Umstand, sondern der Punkt: `new
 * Date('2026-08-19T10:00')` und `new Date('2026-08-19')` legen dieselbe
 * Zeichenkette unterschiedlich aus — die erste als lokale Zeit, die zweite als
 * UTC. Mit `new Date(jahr, monat, …)` ist die Auslegung eindeutig lokal.
 *
 * Herausgelöst aus `bookings/RescheduleDialog.tsx`, wo die drei Funktionen
 * zuerst standen. Eine zweite Kopie im Gerätedialog wäre der Anfang zweier
 * Auslegungen desselben Formats.
 */

const pad = (value: number): string => String(value).padStart(2, '0');

/** Zeitpunkt → Wert für ein `<input type="date">`. */
export function dateValue(instant: Date): string {
  return `${instant.getFullYear()}-${pad(instant.getMonth() + 1)}-${pad(instant.getDate())}`;
}

/** Zeitpunkt → Wert für ein `<input type="time">`. */
export function timeValue(instant: Date): string {
  return `${pad(instant.getHours())}:${pad(instant.getMinutes())}`;
}

/** Beide Feldwerte zurück zu einem Zeitpunkt; `undefined`, solange etwas fehlt. */
export function combine(date: string, time: string): Date | undefined {
  if (!date || !time) return undefined;
  const [year, month, day] = date.split('-').map(Number);
  const [hour, minute] = time.split(':').map(Number);
  if ([year, month, day, hour, minute].some((part) => part === undefined || Number.isNaN(part))) {
    return undefined;
  }
  return new Date(year!, month! - 1, day!, hour!, minute!, 0, 0);
}

/** Einheitliche Anzeige eines Zeitpunkts in Betriebszeit. */
export function formatInstant(iso: string | Date, style: 'short' | 'medium' = 'short'): string {
  return new Intl.DateTimeFormat('de-DE', {
    timeZone: 'Europe/Berlin',
    dateStyle: 'short',
    timeStyle: style,
  }).format(new Date(iso));
}
